import { tokenHasPlatform } from './index';
import { DocumentUploadsExperience } from '../types/document-uploads';
import { DepositFormsExperience } from '../types/dd-forms';
import shouldSkipPartnerBased from './should-skip-partner-based';
import { getSelfIdNextRoute } from './self-id-navigation';
export var defaultSearchState = function (platformType) {
    return platformType === 'time_and_attendance'
        ? '/search/platforms'
        : '/search/search';
};
export var postIntroState = function (linkTokenPayload, featureFlags, visitedWizard) {
    var _a, _b;
    // Token creation validates that we don't have both depositForms and documentUploads set to DIRECT
    if ((linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.depositForms) === DepositFormsExperience.DIRECT) {
        return '/dd-form/primer';
    }
    // Edge case: when `documentUploads` is set to `DIRECT` and a platform token
    // is also set, have the document uploads flow take precedence. In the future,
    // we will want to instead have a token creation validation check for this.
    if ((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.documentUploadsEnabled) &&
        (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.documentUploads) === DocumentUploadsExperience.DIRECT) {
        return '/document-uploads/primer';
    }
    if (linkTokenPayload.accountId) {
        return '/link-api/login';
    }
    if (linkTokenPayload.enableBillNavigator) {
        return '/bill-navigator-iframe';
    }
    // SelfId flow should be validated after direct deposit flow end direct document uploads flags
    if (linkTokenPayload.enableSelfId &&
        ((_a = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.missingUserAuthenticationFields) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return getSelfIdNextRoute(linkTokenPayload);
    }
    // Edge case if selfId is enabled and all required fields are provided
    if (linkTokenPayload.enableSelfId &&
        ((_b = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.missingUserAuthenticationFields) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        return '/multi-supplier-eligibility/lookup';
    }
    if (linkTokenPayload.hasUserAuthenticationData) {
        if (shouldSkipPartnerBased(linkTokenPayload)) {
            // If this evaluates to false, fall back to default search state
            if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowBackgroundEligibilityCheck) {
                return '/multi-supplier-eligibility/lookup';
            }
        }
        else if ((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.eligibilityCheckWhenTokenHasPlatform) ||
            !tokenHasPlatform(linkTokenPayload)) {
            return '/multi-supplier-eligibility/lookup';
        }
    }
    if (tokenHasPlatform(linkTokenPayload)) {
        return '/link-api/login';
    }
    if (featureFlags.wizardEnabled && !visitedWizard) {
        return '/wizard/income-sources';
    }
    return defaultSearchState(linkTokenPayload.platformType);
};
